import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Plus,
  Edit3,
  Trash2,
  RefreshCw,
  Download,
  Search,
  ChevronLeft,
  ChevronRight,
  Users,
  Settings,
  Play,
  GitBranch,
  List,
  BarChart2,
  Upload,
  X,
  Check,
  MoreVertical,
  Sparkles,
} from "lucide-react";
import { UploaderComponent } from "@syncfusion/ej2-react-inputs";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { DialogUtility } from "@syncfusion/ej2-react-popups";
import * as ProcessActions from "../../redux/actions/process.actions";
import DialogFormItem from "../dialog/DialogFormItem";
import DialogFlowVarsTemplate from "../dialog/DialogFlowVarsTemplate";
import DialogVersionsTemplate from "../dialog/DialogVersionsTemplate";
import DialogInitFlowTemplate from "../dialog/DialogInitFlowTemplate";
import DialogSetActorToUserTemplate from "../dialog/DialogSetActorToUserTemplate";
import DialogAdminResetPasswordTemplate from "../dialog/DialogAdminResetPasswordTemplate";
import DialogReports from "../dialog/DialogReports";
import EndPoint from "../../api/Endpoints";
import ApiClient from "../../api/ApiClient";

const PAGE_SIZE = 15;

const ICON_MAP = {
  add: <Plus size={14} />,
  edit: <Edit3 size={14} />,
  delete: <Trash2 size={14} />,
  addform: <Plus size={14} />,
  editform: <Edit3 size={14} />,
  addconnector: <Plus size={14} />,
  editconnector: <Edit3 size={14} />,
  adddashboard: <Plus size={14} />,
  editdashboard: <Edit3 size={14} />,
  managediagram: <GitBranch size={14} />,
  flowstudio: <Sparkles size={14} />,
  managevariables: <Settings size={14} />,
  manageorgchart: <Users size={14} />,
  defineversions: <List size={14} />,
  initflow: <Play size={14} />,
  addactors: <Users size={14} />,
  addusers: <Users size={14} />,
  addoffices: <Users size={14} />,
  addusersO: <Users size={14} />,
  resetpassword: <Settings size={14} />,
  report: <BarChart2 size={14} />,
  createdeploy: <Play size={14} />,
  deletedeploy: <Trash2 size={14} />,
  import: <Upload size={14} />,
  export: <Download size={14} />,
};

const ManageTable = (props) => {
  const { componentName } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { componentConfig, requesting } = useSelector((state) => state.Process);
  const { usertoken, defConfig, defLang } = useSelector((state) => state.Login);

  /* ── dialog visibility ── */
  const [formDialog, setFormDialog] = React.useState(false);
  const [formDialogABM, setFormDialogABM] = React.useState(false);
  const [reportDialog, setReportDialog] = React.useState(false);
  const [reportDialogKey, setReportDialogKey] = React.useState(0);
  const [reportDialogUpload, setReportDialogUpload] = React.useState(false);
  const [flowVariableDialog, setFlowVariableDialog] = React.useState(false);
  const [versionsDialog, setVersionsDialog] = React.useState(false);
  const [initFlowDialog, setInitFlowDialog] = React.useState(false);
  const [actorUserDialog, setActorUserDialog] = React.useState(false);
  const [resetPasswordDialog, setResetPasswordDialog] = React.useState(false);

  /* ── feature flags ── */
  const [ADvariables, setADvariables] = React.useState(false);
  const [ADdefineversion, setADdefineversion] = React.useState(false);
  const [ADinitflow, setADinitflow] = React.useState(false);
  const [ADactorUser, setADactorUser] = React.useState(false);
  const [formReport, setFormReport] = React.useState(false);
  const [massiveLoadComponent, setMassiveLoadComponent] = React.useState(false);

  /* ── action meta ── */
  const [filters, setFilters] = React.useState(false);
  const [filterValue, setFilterValue] = React.useState(false);
  const [reportInfo, setReportInfo] = React.useState({});
  const [deployApi, setDeployApi] = React.useState("");
  const [deldeployApi, setDeldeployApi] = React.useState("");
  const [roles, setRoles] = React.useState([]);

  /* ── form state ── */
  const [header, setHeader] = React.useState("");
  const [action, setAction] = React.useState("add");
  const [id, setId] = React.useState(0);
  const [code, setCode] = React.useState("");
  const [itemType, setItemType] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const selectedRowRef = React.useRef(null);

  const selectRow = (row) => {
    selectedRowRef.current = row;
    setSelectedRow(row);
  };

  /* ── table UI ── */
  const [searchText, setSearchText] = React.useState("");
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [toolbarButtons, setToolbarButtons] = React.useState([]);
  const [loadingPage, setLoadingPage] = React.useState(false);

  const uploadObjRef = React.useRef(null);
  const searchInputRef = React.useRef(null);
  const searchWrapperRef = React.useRef(null);
  let dialogObj;

  /* auto-focus when search opens */
  React.useEffect(() => {
    if (searchOpen && searchInputRef.current) searchInputRef.current.focus();
  }, [searchOpen]);

  /* close search on click-outside */
  React.useEffect(() => {
    if (!searchOpen) return;
    const handler = (e) => {
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(e.target))
        setSearchOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [searchOpen]);

  const logsformFields = React.useMemo(
    () => [
      {
        name: "id",
        label: defConfig[defLang].loadid,
        type: "text",
        action: "",
        variant: "",
        value: "",
        values: [],
        id: 1,
        layout_id: "1_layout",
        layout_maxSizeY: 2,
        layout_minSizeY: 1,
        layout_row: 0,
        layout_col: 0,
        layout_sizeX: 12,
        layout_sizeY: 2,
      },
    ],
    [defConfig, defLang]
  );

  const reportInfoUpload = React.useMemo(
    () => ({
      header: [
        { field: "LOADID", label: "Id" },
        { field: "STATUS", label: defConfig[defLang].statuslabel },
        { field: "RESPONSE", label: defConfig[defLang].responselabel },
      ],
      apiName: "/files/get-bulk-data",
    }),
    [defConfig, defLang]
  );

  const columns = componentConfig.columns || [];
  const primaryKey = columns[0]?.id;

  /* ── filtered + paginated rows ── */
  const filteredRows = React.useMemo(() => {
    const rows = componentConfig.rows || [];
    const q = searchText.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((row) =>
      columns.some((col) => {
        const val = row[col.id];
        return val != null && String(val).toLowerCase().includes(q);
      })
    );
  }, [componentConfig.rows, columns, searchText]);

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const pageRows = filteredRows.slice(
    (safePage - 1) * PAGE_SIZE,
    safePage * PAGE_SIZE
  );

  /* ── helpers ── */
  const getRowId = () => selectedRowRef.current?.[primaryKey];

  const getEntityLabel = () =>
    defConfig[defLang][componentConfig.sigleComponentName] ||
    componentConfig.sigleComponentName ||
    "";

  /* reset all local + dialog state when navigating to a different component */
  React.useEffect(() => {
    setSearchText("");
    setSearchOpen(false);
    setPage(1);
    selectRow(null);
    /* close all dialogs so stale Redux formFields don't mount CompFormDesinger etc. */
    setFormDialog(false);
    setFormDialogABM(false);
    setReportDialog(false);
    setReportDialogUpload(false);
    setFlowVariableDialog(false);
    setVersionsDialog(false);
    setInitFlowDialog(false);
    setActorUserDialog(false);
    setResetPasswordDialog(false);
    setADvariables(false);
    setADdefineversion(false);
    setADinitflow(false);
    setADactorUser(false);
    setFormReport(false);
    setMassiveLoadComponent(false);
  }, [componentName]);

  const refreshTable = () => {
    dispatch(ProcessActions.getComponentConfig(componentName, defLang));
    selectRow(null);
  };

  const getRoles = async () => {
    const resp = await ApiClient.doPost(EndPoint.getRoles);
    if (resp.status) setRoles(resp.result);
  };

  /* ── build toolbar from actions config ── */
  React.useEffect(() => {
    if (!componentConfig.actions) return;

    const opts = componentConfig.actions.map((a) => a.name);
    const btns = [];

    setFormDialogABM(opts.includes("create") || opts.includes("update"));
    setMassiveLoadComponent(opts.includes("massiveload"));

    if (opts.includes("create")) {
      btns.push({ id: "add", label: defConfig[defLang]["createlabel"], needsSel: false });
    }
    if (opts.includes("update")) {
      btns.push({ id: "edit", label: defConfig[defLang]["editlabel"], needsSel: true });
    }
    if (opts.includes("delete")) {
      btns.push({ id: "delete", label: defConfig[defLang]["deletelabel"] || "Eliminar", needsSel: true, danger: true });
    }
    if (opts.includes("addform")) {
      btns.push({ id: "addform", label: defConfig[defLang]["createlabel"], needsSel: false });
    }
    if (opts.includes("editform")) {
      btns.push({ id: "editform", label: defConfig[defLang]["editlabel"], needsSel: true });
    }
    if (opts.includes("addconnector")) {
      btns.push({ id: "addconnector", label: defConfig[defLang]["createlabel"], needsSel: false });
    }
    if (opts.includes("editconnector")) {
      btns.push({ id: "editconnector", label: defConfig[defLang]["editlabel"], needsSel: true });
    }
    if (opts.includes("adddashboard")) {
      btns.push({ id: "adddashboard", label: defConfig[defLang]["createlabel"], needsSel: false });
    }
    if (opts.includes("editdashboard")) {
      btns.push({ id: "editdashboard", label: defConfig[defLang]["editlabel"], needsSel: true });
    }

    if (opts.includes("managediagram")) {
      btns.push({ id: "managediagram", label: defConfig[defLang]["managediagramlabel"], needsSel: false });
      // FlowStudio (nuevo editor, React Flow) convive con el legacy: mismo
      // contrato de guardado, se ofrece como opción adicional junto al
      // editor de diagrama existente. Necesita selección: abre el flujo
      // elegido en /flowStudio/:id (ruta propia, no overlay inline).
      btns.push({ id: "flowstudio", label: defConfig[defLang]["flowstudiolabel"], needsSel: true });
    }
    if (opts.includes("managevariables")) {
      btns.push({ id: "managevariables", label: defConfig[defLang]["managevariableslabel"], needsSel: true });
      setADvariables(true);
      getRoles();
    } else {
      setADvariables(false);
    }
    if (opts.includes("manageorgchart")) {
      btns.push({ id: "manageorgchart", label: defConfig[defLang]["manageorgchartlabel"], needsSel: false });
    }
    if (opts.includes("defineversions")) {
      btns.push({ id: "defineversions", label: defConfig[defLang]["defineversionslabel"], needsSel: true });
      setADdefineversion(true);
    } else {
      setADdefineversion(false);
    }
    if (opts.includes("initflow")) {
      btns.push({ id: "initflow", label: defConfig[defLang]["initflowlabel"], needsSel: true });
      setADinitflow(true);
    } else {
      setADinitflow(false);
    }

    const hasActorAction =
      opts.includes("addactors") ||
      opts.includes("addusers") ||
      opts.includes("addoffices") ||
      opts.includes("addusersO");

    if (hasActorAction) {
      setADactorUser(true);
      if (opts.includes("addactors"))
        btns.push({ id: "addactors", label: defConfig[defLang]["addactorslabel"], needsSel: true });
      if (opts.includes("addusers"))
        btns.push({ id: "addusers", label: defConfig[defLang]["adduserslabel"], needsSel: true });
      if (opts.includes("addoffices"))
        btns.push({ id: "addoffices", label: defConfig[defLang]["addofficeslabel"], needsSel: true });
      if (opts.includes("addusersO"))
        btns.push({ id: "addusersO", label: defConfig[defLang]["addusersOlabel"], needsSel: true });
    } else {
      setADactorUser(false);
    }

    if (opts.includes("report")) {
      const pos = componentConfig.actions.findIndex((a) => a.name === "report");
      const info = componentConfig.actions[pos];
      setFilters(info.conditionfields);
      setReportInfo(info);
      btns.push({ id: "report", label: info.label, needsSel: true });
      setFormReport(true);
    } else {
      setFormReport(false);
      setFilters({});
    }

    if (opts.includes("createdeploy")) {
      const info = componentConfig.actions.find((a) => a.name === "createdeploy");
      setDeployApi(info.apiName);
      btns.push({ id: "createdeploy", label: info.label, needsSel: true });
    }
    if (opts.includes("deletedeploy")) {
      const info = componentConfig.actions.find((a) => a.name === "deletedeploy");
      setDeldeployApi(info.apiName);
      btns.push({ id: "deletedeploy", label: info.label, needsSel: true, danger: true });
    }

    // Accion propia de /manage/users (no viene del componentConfig del server):
    // permite a un admin fijar una nueva contraseña para el usuario seleccionado.
    if (componentName === "users") {
      btns.push({ id: "resetpassword", label: "Resetear contraseña", needsSel: true });
    }

    btns.push({ id: "export", label: "Exportar", needsSel: false });

    setToolbarButtons(btns);
  }, [props, componentConfig.actions, usertoken, componentName]);

  /* ── action handlers ── */
  const clickHandler = (actionId) => {
    const rowId = getRowId();
    setAction(actionId);
    setHeader(getEntityLabel());

    switch (actionId) {
      case "add":
        dispatch(
          ProcessActions.getFormData({
            code: componentName,
            domainid: 6,
            defLang,
            id: null,
            componentConfig,
          })
        );
        setHeader(`${getEntityLabel()} - ${defConfig[defLang].createlabel}`);
        setFormDialog(true);
        setId(0);
        break;

      case "edit":
        if (!selectedRow) return alert("Seleccione un registro para editar");
        setId(rowId);
        dispatch(
          ProcessActions.getFormData({
            code: componentName,
            domainid: 6,
            defLang,
            id: rowId,
            componentConfig,
          })
        );
        setHeader(`${getEntityLabel()} - ${defConfig[defLang].updatelabel}`);
        setFormDialog(true);
        break;

      case "delete":
        if (!selectedRow) return alert("Seleccione un registro para eliminar");
        if (!window.confirm("¿Confirmar eliminación del registro seleccionado?")) return;
        if (componentConfig.customcomponent) {
          dispatch(ProcessActions.processData("customcomponents", "delete", { id: rowId, componentConfig }));
        } else {
          dispatch(ProcessActions.processData(componentName, "delete", { id: rowId }));
        }
        selectRow(null);
        break;

      case "addform":
        navigate("/manageForm/0");
        break;

      case "editform":
        if (!selectedRow) return alert("Seleccione un registro");
        dispatch(ProcessActions.getFormData({ code: "forms", domainid: 6, defLang, id: parseInt(rowId), componentConfig }));
        navigate("/manageForm/" + rowId);
        break;

      case "addconnector":
        navigate("/manageConnector/0");
        break;

      case "editconnector":
        if (!selectedRow) return alert("Seleccione un registro");
        navigate("/manageConnector/" + rowId);
        break;

      case "adddashboard":
        navigate("/manageDashboard/0");
        break;

      case "editdashboard":
        if (!selectedRow) return alert("Seleccione un registro");
        navigate("/manageDashboard/" + rowId);
        break;

      case "managediagram":
        // Antes abría el editor legacy como overlay inline; ahora navega a
        // su propia página (misma ruta que se usa al abrir /manageDiagram/:id
        // directamente), igual que "flowstudio".
        navigate("/manageDiagram/" + (rowId || 0));
        break;

      case "flowstudio":
        if (!selectedRow) return alert("Seleccione un registro");
        navigate("/flowStudio/" + rowId);
        break;

      case "manageorgchart":
        navigate("/manageOrgChart");
        break;

      case "managevariables":
        if (!selectedRow) return alert("Seleccione un registro");
        dispatch(ProcessActions.fetchData("flows", "get-flow-vars", { id: rowId }));
        setId(rowId);
        setFlowVariableDialog(true);
        break;

      case "initflow":
        if (!selectedRow) return alert("Seleccione un registro");
        dispatch(ProcessActions.fetchData("flows", "get-flow-vars", { id: rowId }));
        setId(rowId);
        setCode(selectedRow.FLOWCODE);
        setInitFlowDialog(true);
        break;

      case "defineversions":
        if (!selectedRow) return alert("Seleccione un registro");
        dispatch(ProcessActions.fetchData("flows", "get-flow-versions", { id: rowId }));
        setId(rowId);
        setVersionsDialog(true);
        break;

      case "addactors":
        if (!selectedRow) return alert("Seleccione un registro");
        setItemType("actors");
        dispatch(ProcessActions.fetchData("actors", "get-actors-by-userid", { id: rowId }));
        setId(rowId);
        setActorUserDialog(true);
        break;

      case "addusers":
        if (!selectedRow) return alert("Seleccione un registro");
        setItemType("users");
        dispatch(ProcessActions.fetchData("actors", "get-users-by-actorid", { id: rowId }));
        setId(rowId);
        setActorUserDialog(true);
        break;

      case "addoffices":
        if (!selectedRow) return alert("Seleccione un registro");
        setItemType("offices");
        dispatch(ProcessActions.fetchData("offices", "get-offices-by-userid", { id: rowId }));
        setId(rowId);
        setActorUserDialog(true);
        break;

      case "addusersO":
        if (!selectedRow) return alert("Seleccione un registro");
        setItemType("usersO");
        dispatch(ProcessActions.fetchData("offices", "get-users-by-officeid", { id: rowId }));
        setId(rowId);
        setActorUserDialog(true);
        break;

      case "report":
        if (!selectedRow) return alert("Seleccione un registro");
        setFilterValue(selectedRow[filters[0]]);
        setId(rowId);
        setReportDialogKey((current) => current + 1);
        setReportDialog(true);
        break;

      case "createdeploy":
        if (!selectedRow) return alert("Seleccione un registro");
        setId(rowId);
        dialogObj = DialogUtility.confirm({
          title: "Deploy Component",
          content: "Confirm to deployment this component?",
          okButton: { click: () => confirmDeploy(rowId, deployApi) },
          cancelButton: { click: () => dialogObj.hide() },
          position: { X: "center", Y: "center" },
          closeOnEscape: true,
        });
        break;

      case "deletedeploy":
        if (!selectedRow) return alert("Seleccione un registro");
        setId(rowId);
        dialogObj = DialogUtility.confirm({
          title: "Delete Deploy",
          content: "Confirm to cancel this deployment?",
          okButton: { click: () => confirmDeploy(rowId, deldeployApi) },
          cancelButton: { click: () => dialogObj.hide() },
          position: { X: "center", Y: "center" },
          closeOnEscape: true,
        });
        break;

      case "resetpassword":
        if (!selectedRow) return alert("Seleccione un usuario");
        setId(rowId);
        setResetPasswordDialog(true);
        break;

      case "export":
        exportCsv();
        break;

      default:
        break;
    }
  };

  const confirmDeploy = (rowId, api) => {
    dispatch(
      ProcessActions.processData(componentConfig.componentName, api, {
        id: rowId,
        componentName: componentConfig.componentName,
      })
    );
    if (dialogObj) dialogObj.hide();
  };

  const exportCsv = () => {
    const rows = componentConfig.rows || [];
    const headers = columns.map((c) => `"${c.label}"`).join(",");
    const body = rows
      .map((row) =>
        columns
          .map((c) => `"${String(row[c.id] ?? "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");
    const blob = new Blob([headers + "\n" + body], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = (componentConfig.componentName || "export") + ".csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const massiveLoad = async () => {
    setLoadingPage(true);
    const formData = new FormData();
    const uploadedFiles = uploadObjRef.current.filesData;
    formData.append("filename", uploadedFiles[0].rawFile);
    formData.append("componentcode", componentConfig.componentName);
    const response = await ApiClient.doPost(EndPoint["bulkData"], formData);
    if (response.status) {
      logsformFields[0]["value"] = response.id;
      setReportDialogUpload(true);
    }
    setLoadingPage(false);
  };

  /* ── cell renderer ── */
  const cellValue = (row, col) => {
    const val = row[col.id];
    if (val == null) return val;
    const str = String(val);
    if (str.startsWith("FLAG_RED")) {
      return (
        <span className="xmt-badge xmt-badge-danger">
          {str.replace("FLAG_RED", "").trim()}
        </span>
      );
    }
    if (str.startsWith("FLAG_YELLOW")) {
      return (
        <span className="xmt-badge xmt-badge-warning">
          {str.replace("FLAG_YELLOW", "").trim()}
        </span>
      );
    }
    if (col.id.includes("URL_")) {
      let url = str;
      let name = str;
      if (str.includes("___")) {
        const parts = str.split("___");
        url = parts[0];
        name = parts[1];
      }
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      );
    }
    return val;
  };

  /* ── pagination pages array ── */
  const paginationPages = React.useMemo(() => {
    const pages = [];
    for (let p = 1; p <= totalPages; p++) {
      if (
        p === 1 ||
        p === totalPages ||
        Math.abs(p - safePage) <= 2
      ) {
        pages.push(p);
      }
    }
    const result = [];
    pages.forEach((p, idx) => {
      if (idx > 0 && p - pages[idx - 1] > 1) result.push("...");
      result.push(p);
    });
    return result;
  }, [totalPages, safePage]);

  const isEmpty = filteredRows.length === 0;

  return (
    <>
      {/* ── Dialogs ── */}
      {formDialogABM && (
        <DialogFormItem
          header={header}
          id={id}
          status={formDialog}
          action={action}
          componentName={componentConfig.componentName}
          animationSettings={{ effect: "Fade" }}
          close={() => setFormDialog(false)}
          open={() => setFormDialog(true)}
        />
      )}
      {ADvariables && (
        <DialogFlowVarsTemplate
          roles={roles}
          header={header}
          id={id}
          selectedRecord={selectedRow}
          status={flowVariableDialog}
          animationSettings={{ effect: "SlideRight" }}
          close={() => setFlowVariableDialog(false)}
          open={() => setFlowVariableDialog(true)}
        />
      )}
      {formReport && (
        <DialogReports
          filters={filters}
          header={header}
          key={reportDialogKey}
          filterValue={filterValue}
          reportInfo={reportInfo}
          id={id}
          status={reportDialog}
          animationSettings={{ effect: "SlideRight" }}
          close={() => setReportDialog(false)}
          open={() => setReportDialog(true)}
        />
      )}
      {ADdefineversion && (
        <DialogVersionsTemplate
          header={header}
          id={id}
          selectedRecord={selectedRow}
          status={versionsDialog}
          animationSettings={{ effect: "SlideRight" }}
          close={() => setVersionsDialog(false)}
          open={() => setVersionsDialog(true)}
        />
      )}
      {ADinitflow && (
        <DialogInitFlowTemplate
          header={header}
          id={id}
          code={code}
          selectedRecord={selectedRow}
          status={initFlowDialog}
          animationSettings={{ effect: "SlideRight" }}
          close={() => setInitFlowDialog(false)}
          open={() => setInitFlowDialog(true)}
        />
      )}
      {ADactorUser && (
        <DialogSetActorToUserTemplate
          header={header}
          id={id}
          selectedRecord={selectedRow}
          status={actorUserDialog}
          itemType={itemType}
          componentName={componentConfig.componentName}
          animationSettings={{ effect: "SlideRight" }}
          close={() => setActorUserDialog(false)}
          open={() => setActorUserDialog(true)}
        />
      )}
      {componentName === "users" && (
        <DialogAdminResetPasswordTemplate
          id={id}
          status={resetPasswordDialog}
          entityLabel={selectedRow ? (selectedRow.USERNAME || selectedRow.EMAIL || "") : ""}
          close={() => setResetPasswordDialog(false)}
        />
      )}

      {/* ── Massive load ── */}
      {massiveLoadComponent && (
        <div className="xmt-massive-load">
          <h5>{defConfig[defLang].massiveloadtitle}</h5>
          <form id="formBulk" method="post">
            <UploaderComponent
              id="file"
              type="file"
              ref={(scope) => { uploadObjRef.current = scope; }}
              autoUpload={false}
              multiple={false}
              allowedExtensions=".xls, .xlsx"
            />
          </form>
          <div className="xmt-massive-actions">
            <ButtonComponent className="e-success" onClick={massiveLoad} disabled={loadingPage}>
              {loadingPage ? defConfig[defLang].uploadingfilelabel : defConfig[defLang].uploadfilelabel}
            </ButtonComponent>
            <ButtonComponent className="e-secondary" onClick={() => setReportDialogUpload(true)}>
              {defConfig[defLang].showloadslabel}
            </ButtonComponent>
            <ButtonComponent className="e-info" onClick={refreshTable} disabled={loadingPage}>
              {defConfig[defLang].refreshtablelabel}
            </ButtonComponent>
          </div>
          {!loadingPage && (
            <DialogReports
              header={defConfig[defLang].statusloadtitle}
              status={reportDialogUpload}
              reportInfo={reportInfoUpload}
              formFields={logsformFields}
              filterValue={massiveLoadComponent}
              animationSettings={{ effect: "SlideRight" }}
              close={() => setReportDialogUpload(false)}
              open={() => setReportDialogUpload(true)}
            />
          )}
        </div>
      )}

      {/* ── Main table UI ── */}
      <div className="xmt-manager">

        {/* ── DESKTOP toolbar ── */}
        <div className="xflow-template-toolbar xmt-toolbar">
          <div className="xmt-action-strip">
            {toolbarButtons.map((btn) => {
              const isReady = btn.needsSel && !!selectedRow;
              const cls = isReady
                ? btn.danger ? "xmt-btn-danger xmt-btn--ready-danger" : "xmt-btn--ready"
                : btn.danger ? "xmt-btn-danger" : "";
              return (
                <button key={btn.id} type="button" className={cls}
                  disabled={btn.needsSel && !selectedRow}
                  onClick={() => clickHandler(btn.id)}>
                  {ICON_MAP[btn.id] || <Settings size={14} />}
                  {btn.label}
                </button>
              );
            })}
          </div>
          <div className="xmt-util-strip">
            <span className="xmt-row-count">{filteredRows.length} reg.</span>
            <div className="xmt-search-wrapper" ref={searchWrapperRef}>
              <button type="button"
                className={"xmt-search-btn" + (searchOpen ? " xmt-search-btn--active" : "") + (searchText && !searchOpen ? " xmt-search-btn--filled" : "")}
                onClick={() => setSearchOpen((s) => !s)} title="Buscar">
                <Search size={14} />
                {searchText && !searchOpen && <span className="xmt-search-dot" />}
              </button>
              {searchOpen && (
                <div className="xmt-search-popup">
                  <Search size={13} className="xmt-search-popup-icon" />
                  <input ref={searchInputRef} type="text" placeholder="Buscar..."
                    value={searchText}
                    onChange={(e) => { setSearchText(e.target.value); setPage(1); }}
                    autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
                    onKeyDown={(e) => { if (e.key === "Escape") setSearchOpen(false); }} />
                  {searchText && (
                    <button type="button" className="xmt-search-clear"
                      onClick={() => { setSearchText(""); setPage(1); searchInputRef.current?.focus(); }}>
                      <X size={12} />
                    </button>
                  )}
                </div>
              )}
            </div>
            <button type="button" className="xflow-template-refresh"
              onClick={refreshTable} disabled={requesting} title="Actualizar">
              <RefreshCw size={14} className={requesting ? "xmt-spin" : ""} />
            </button>
          </div>
        </div>

        {/* Desktop selection bar */}
        {selectedRow && (
          <div className="xmt-sel-bar">
            <div className="xmt-sel-bar-icon"><Edit3 size={13} /></div>
            <span className="xmt-sel-bar-label">Seleccionado</span>
            <div className="xmt-sel-bar-fields">
              {columns.slice(0, 5).map((col) => {
                const val = selectedRow[col.id];
                if (val == null || String(val).trim() === "") return null;
                return (
                  <span key={col.id} className="xmt-sel-chip">
                    <span className="xmt-sel-chip-label">{col.label}:</span>
                    <span className="xmt-sel-chip-value">{String(val)}</span>
                  </span>
                );
              })}
            </div>
            <button type="button" className="xmt-sel-bar-clear" onClick={() => selectRow(null)}>
              <X size={12} /> Quitar
            </button>
          </div>
        )}

        {/* ── DESKTOP table ── */}
        <div className="xflow-template-table-wrap">
          <table className="xflow-template-table xmt-table">
            <thead>
              <tr>
                {columns.map((col) => (
                  <th key={col.id} style={{
                    minWidth: col.minWidth || 100,
                    textAlign: col.textAlign === "Center" ? "center" : col.textAlign === "Right" ? "right" : "left",
                  }}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {requesting ? (
                Array.from({ length: 8 }).map((_, i) => (
                  <tr key={`sk-${i}`}>
                    {columns.map((col) => (
                      <td key={col.id}><span className="xft-skeleton-cell" /></td>
                    ))}
                  </tr>
                ))
              ) : isEmpty ? (
                <tr>
                  <td colSpan={columns.length} className="xmt-empty-cell">
                    {searchText ? "Sin resultados para la búsqueda." : "No hay registros."}
                  </td>
                </tr>
              ) : (
                pageRows.map((row, idx) => {
                  const isSelected = selectedRow && primaryKey && row[primaryKey] === selectedRow[primaryKey];
                  return (
                    <tr key={row[primaryKey] ?? idx}
                      className={isSelected ? "xflow-template-row-selected" : ""}
                      onClick={() => selectRow(isSelected ? null : row)}
                      onDoubleClick={() => {
                        selectRow(row);
                        if (formDialogABM) {
                          const rowId = row[primaryKey];
                          setId(rowId);
                          dispatch(ProcessActions.getFormData({ code: componentName, domainid: 6, defLang, id: rowId, componentConfig }));
                          setHeader(`${getEntityLabel()} - ${defConfig[defLang].updatelabel}`);
                          setAction("edit");
                          setFormDialog(true);
                        }
                      }}>
                      {columns.map((col) => (
                        <td key={col.id}>{cellValue(row, col)}</td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Desktop pagination */}
        {!isEmpty && totalPages > 1 && (
          <div className="xmt-pagination">
            <button type="button" disabled={safePage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
              <ChevronLeft size={14} />
            </button>
            {paginationPages.map((item, idx) =>
              item === "..." ? (
                <span key={`el-${idx}`} className="xmt-pg-ellipsis">…</span>
              ) : (
                <button key={item} type="button"
                  className={item === safePage ? "xmt-pg-active" : ""}
                  onClick={() => setPage(item)}>{item}</button>
              )
            )}
            <button type="button" disabled={safePage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
              <ChevronRight size={14} />
            </button>
            <span className="xmt-pg-info">Pág {safePage} de {totalPages}</span>
          </div>
        )}

        {/* ── MOBILE: top bar (search + count + refresh) ── */}
        <div className="xmt-mobile-topbar">
          <div className="xmt-mobile-search">
            <Search size={14} className="xmt-mobile-search-icon" />
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Buscar..."
              value={searchText}
              onChange={(e) => { setSearchText(e.target.value); setPage(1); }}
              autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
            />
            {searchText && (
              <button type="button" className="xmt-search-clear"
                onClick={() => { setSearchText(""); setPage(1); }}>
                <X size={12} />
              </button>
            )}
          </div>
          <span className="xmt-row-count">{filteredRows.length} reg.</span>
          <button type="button" className="xflow-template-refresh xmt-mobile-refresh"
            onClick={refreshTable} disabled={requesting} title="Actualizar">
            <RefreshCw size={15} className={requesting ? "xmt-spin" : ""} />
          </button>
        </div>

        {/* ── MOBILE: card list ── */}
        <div className="xmt-mobile-list">
          {requesting ? (
            Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="xmt-mc xmt-mc--skeleton">
                <div className="xmt-mc-skel-title" />
                <div className="xmt-mc-skel-row" />
                <div className="xmt-mc-skel-row xmt-mc-skel-row--short" />
              </div>
            ))
          ) : isEmpty ? (
            <div className="xmt-mc-empty">
              {searchText ? "Sin resultados para la búsqueda." : "No hay registros."}
            </div>
          ) : (
            pageRows.map((row, idx) => {
              const isSelected = selectedRow && primaryKey && row[primaryKey] === selectedRow[primaryKey];
              return (
                <div key={row[primaryKey] ?? idx}
                  className={"xmt-mc" + (isSelected ? " xmt-mc--selected" : "")}
                  onClick={() => selectRow(isSelected ? null : row)}>
                  <div className="xmt-mc-header">
                    <div className="xmt-mc-title">{cellValue(row, columns[0])}</div>
                    <button
                      type="button"
                      className={"xmt-mc-more" + (isSelected ? " xmt-mc-more--active" : "")}
                      onClick={(e) => { e.stopPropagation(); selectRow(isSelected ? null : row); }}
                      title="Opciones"
                    >
                      {isSelected ? <Check size={14} /> : <MoreVertical size={16} />}
                    </button>
                  </div>
                  {columns.length > 1 && (
                    <div className="xmt-mc-fields">
                      {columns.slice(1).map((col) => {
                        const val = cellValue(row, col);
                        if (!val) return null;
                        return (
                          <div key={col.id} className="xmt-mc-field">
                            <span className="xmt-mc-label">{col.label}</span>
                            <span className="xmt-mc-value">{val}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })
          )}

          {/* Mobile pagination */}
          {!isEmpty && totalPages > 1 && (
            <div className="xmt-mc-pager">
              <button type="button" disabled={safePage <= 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}>
                <ChevronLeft size={16} />
              </button>
              <span>{safePage} / {totalPages}</span>
              <button type="button" disabled={safePage >= totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
                <ChevronRight size={16} />
              </button>
            </div>
          )}
        </div>

      </div>

      {/* ── MOBILE FAB — primary create action ── */}
      {(() => {
        const fab = toolbarButtons.find((b) => !b.needsSel && b.id !== "export");
        if (!fab) return null;
        return (
          <button type="button" className="xmt-fab" onClick={() => clickHandler(fab.id)} title={fab.label}>
            <Plus size={22} />
          </button>
        );
      })()}

      {/* ── MOBILE bottom action bar (appears when card is selected) ── */}
      {selectedRow && (
        <div className="xmt-mobile-overlay" onClick={() => selectRow(null)} />
      )}
      {selectedRow && (
        <div className="xmt-mobile-bar">
          <div className="xmt-mobile-bar-header">
            <span className="xmt-mobile-bar-title">
              {columns[0] ? String(selectedRow[columns[0].id] ?? "") : "Seleccionado"}
            </span>
            <button type="button" className="xmt-mobile-bar-close" onClick={() => selectRow(null)}>
              <X size={16} />
            </button>
          </div>
          <div className="xmt-mobile-bar-actions">
            {toolbarButtons.filter((b) => b.needsSel).map((btn) => (
              <button key={btn.id} type="button"
                className={"xmt-mobile-bar-btn" + (btn.danger ? " xmt-mobile-bar-btn--danger" : "")}
                onClick={() => clickHandler(btn.id)}>
                {ICON_MAP[btn.id] || <Settings size={16} />}
                <span>{btn.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ManageTable;
